import { useTranslation } from 'react-i18next'

export const OutOfCredits: React.FC = () => {
  const { t } = useTranslation()
  return (
    <main
      className="flex flex-col h-screen justify-center items-center px-4 py-4 bg-gradient-to-b from-blue-50 to-white p-4"
      style={{
        scrollbarWidth: 'none'
      }}
    >
      <h1 className="text-center text-[32px] leading-[35px]">
        {t('out-of-credits.header')}
      </h1>
    </main>
  )
}
